<template>
    <vx-button @click="handleClick"
        :href="href">
        <slot />
    </vx-button>
</template>

<script setup lang="ts">
import { VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import { keepAnchorDefaultBehavior } from '~/utils/dom';

const props = defineProps<{
    to: RouteLocationRaw;
}>();

const router = useRouter();

const href = computed((): string => {
    return router.resolve(props.to).href;
});

const handleClick = (event: MouseEvent|KeyboardEvent) => {
    if (keepAnchorDefaultBehavior(event)) {
        return;
    }

    event.preventDefault();
    router.push(props.to);
}
</script>
